import { Avatar } from '../Avatar/Avatar';
import { PublisherInfoProps } from './types';

import { c } from '../../utils/tailwind-merge';
import { CertifiedPublisher } from '../CertifiedPublisher/CertifiedPublisher';

export const PublisherInfo = ({
  publisherName,
  showAvatar,
  isCertified,
  microcopy,
  size = 'medium',
  className = '',
}: PublisherInfoProps) => {
  return (
    <div className={c('flex items-center', className)}>
      {showAvatar && (
        <Avatar userName={publisherName} size={24} className="bg-grey-900" />
      )}
      <span
        className={c(
          'flex items-center leading-5 text-grey-900',
          size === 'medium' ? 'text-sm' : 'text-xs',
          showAvatar ? 'pl-2' : '',
          isCertified ? 'pr-1' : ''
        )}
      >
        {publisherName}
      </span>
      {isCertified && (
        <CertifiedPublisher microcopy={microcopy.certifiedPublisher} />
      )}
    </div>
  );
};
